const yup = require("yup");
const {
  paymentDetailsSchema,
  requiredPaymentDetailsSchema,
} = require("./paymentDetails");
const { generateCustomFieldsValidation } = require("./customFieldValidations");
const { optionalAddressValidation } = require("./addressValidation");

// Validation schema for adding a business contact
const addBusinessContact = yup.object().shape({
  website: yup.string().required("Website domain is required"),
  businessName: yup.string().required("Business name is required"),
  email: yup
    .string()
    .email("Must be a valid email")
    .required("Email is required"),
  phone: yup.string(),
  address: optionalAddressValidation,
  relationshipType: yup.string().required("Relationship type is required"),
  showPaymentDetails: yup.boolean(),
  paymentDetails: yup.object().when(["showPaymentDetails"], {
    is: (showPaymentDetails) => showPaymentDetails,
    then: () => requiredPaymentDetailsSchema,
    otherwise: () => paymentDetailsSchema,
  }),
});

// Validation schema for adding an individual contact
const addIndividualContact = yup.object().shape({
  firstName: yup
    .string()
    .matches(
      /^[A-Za-z ]*$/,
      "First name can only contain alphabetic characters and spaces",
    )
    .required("First name is required"),
  lastName: yup
    .string()
    .matches(
      /^[A-Za-z ]*$/,
      "Last name can only contain alphabetic characters and spaces",
    )
    .required("Last name is required"),
  email: yup
    .string()
    .email("Must be a valid email")
    .required("Email is required"),
  phone: yup.string(),
  address: optionalAddressValidation,
  relationshipType: yup.string().required("Relationship type is required"),
  showPaymentDetails: yup.boolean(),
  paymentDetails: yup.object().when(["showPaymentDetails"], {
    is: (showPaymentDetails) => showPaymentDetails,
    then: () => requiredPaymentDetailsSchema,
    otherwise: () => paymentDetailsSchema,
  }),
});

const generateBusinessContactValidationSchema = (customFieldSettings = []) => {
  const customFieldsSchema =
    generateCustomFieldsValidation(customFieldSettings);
  return addBusinessContact.concat(
    yup.object({
      customFields: customFieldsSchema, // Add custom fields validation
    }),
  );
};

const generateIndividualContactValidationSchema = (
  customFieldSettings = [],
) => {
  const customFieldsSchema =
    generateCustomFieldsValidation(customFieldSettings);
  return addIndividualContact.concat(
    yup.object({
      customFields: customFieldsSchema,
    }),
  );
};

module.exports = {
  addBusinessContact,
  addIndividualContact,
  generateBusinessContactValidationSchema,
  generateIndividualContactValidationSchema,
};
